import { MARQUEE_ITEMS } from "@/data/site";

export default function Marquee() {
  const items = [...MARQUEE_ITEMS, ...MARQUEE_ITEMS];
  return (
    <div className="overflow-hidden border-y border-[rgba(212,175,55,0.2)] bg-[#0B0B0E] py-5" aria-hidden="true" data-testid="editorial-marquee">
      <div className="marquee-track">
        {items.map((item, i) => (
          <span key={i} className="flex items-center shrink-0">
            <span className="font-display text-2xl sm:text-3xl italic text-[#8A7322] px-8">{item}</span>
            <span className="h-1.5 w-1.5 rotate-45 bg-[#D4AF37]" />
          </span>
        ))}
      </div>
    </div>
  );
}
